module.exports = __webpack_public_path__ + "img/14.837b0781.jpg";